import { AnchorHTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import style from './ui.module.css';

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  children: ReactNode;
  className?: string;
  to: string;
}

const Button = ({ children, className = '', to = '', ...props }: LinkProps) => {
  const baseStyles = `${style['link-style']}`;

  return (
    <Link to={to} className={`${baseStyles} ${className}`} {...props}>
      {children}
    </Link>
  );
};

export default Button;
